import styled from '@emotion/styled/macro';

import { PageSection } from '../Page/Page';

export const ToolsWrapper = styled(PageSection)`
  display: flex;
  align-items: center;
  padding-bottom: 2rem;
`;
